export default class JsonPatch{
  public constructor(
    public op: string,
    public path: string,
    public valueSerialized: string
  ) {}
}
